import React from "react";

function Guarantor() {
	React.useEffect(() => {
		const currentParams = window.location.search;
		window.location.replace(`https://dashboard.lmcsnigltd.org.ng/guarantor-form/${currentParams}`);
	}, []);

	return (
		<div style={{
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
			height: "100vh",
			backgroundColor: "#f0f4f8",
			fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
			color: "#333",
			textAlign: "center",
			padding: "20px"
		}}>
			<div style={{
				background: "#ffffff",
				padding: "40px",
				borderRadius: "16px",
				boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
				maxWidth: "450px",
				width: "100%"
			}}>
				<div style={{
					width: "40px",
					height: "40px",
					border: "3px solid #e2e8f0",
					borderTop: "3px solid #3b82f6",
					borderRadius: "50%",
					animation: "spin 0.8s linear infinite",
					margin: "0 auto 24px"
				}} />
				<h3 style={{ fontSize: "20px", fontWeight: "700", marginBottom: "12px", color: "#1e293b" }}>
					Moving to New Portal
				</h3>
				<p style={{ fontSize: "14px", color: "#64748b", lineHeight: "1.6", margin: 0 }}>
					You are being redirected to the upgraded secure Guarantor Form on our dashboard domain. Please wait a moment...
				</p>
			</div>
			<style>{`
				@keyframes spin {
					0% { transform: rotate(0deg); }
					100% { transform: rotate(360deg); }
				}
			`}</style>
		</div>
	);
}

export default Guarantor;
